module.exports = __webpack_public_path__ + "static/media/Colette Ray Super King Headboard - 120 cm_Beige.4961364b.png";